import { KitIconType } from 'types'

export const kitIcons: KitIconType[] = [
  'africa-middle-east',
  'agriculture',
  'asia-pacific',
  'badge-2',
  'badge',
  'biogas',
  'bolt',
  'calculator',
  'chart',
  'chat',
  'commercial-business',
  'construction',
  'consulting-engineer',
  'continuous-improvement',
  'cost-efficiency',
  'customer',
  'data-centers',
  'dealer',
  'development',
  'disaster-preparedness',
  'distributed-power',
  'education',
  'electrical-contractor',
  'energy-reliability',
  'energy-service',
  'energy-storage',
  'eurasia',
  'europe',
  'eye',
  'family',
  'generation-assets',
  'greenhouses',
  'healthcare',
  'heat-and-power',
  'hydrogen',
  'increased-capacity',
  'it',
  'keys',
  'landfills',
  'latin-america',
  'manufacturing',
  'marketing',
  'microgrid-solutions',
  'mining',
  'mobile-generator',
  'municipality-engineer',
  'municipality',
  'no',
  'north-america',
  'nuclear',
  'other-role',
  'other',
  'owner',
  'person',
  'pin',
  'plant-manager',
  'powerplants',
  'renewable-biofuels',
  'renewables',
  'rental-generators',
  'retention',
  'rotating-clock',
  'solution-consultation',
  'stack',
  'standby-generator',
  'support',
  'sustainability-renewables',
  'sustainability',
  'talent-acquisition-2',
  'talent-acquisition-3',
  'talent-acquisition',
  'talk-to-each-other',
  'technical-person',
  'technician-2',
  'technician-3',
  'technician',
  'telecom',
  'transmission-congestion',
  'utilities',
  'utility-manager',
  'yes',
  'digital-and-content-transformation',
  'events-and-venues',
  'experiential-branding-marketing',
  'facilities',
  'field-sales',
  'innovation-roadmapping',
  'momentify',
  'technical-recruiting',
  'tradeshows-and-exhibits',
  'human-resources',
  'entevate-marketing',
  'entevate-other',
  'recruiter',
]
